import React from 'react';

export default function ConfirmPopup({ message, onConfirm, onCancel }) {
  return (
    <div className="auth-popup-overlay" onClick={onCancel}>
      <div className="auth-popup-content auth-popup-content--confirm" onClick={(e) => e.stopPropagation()}>
        <h2>{message}</h2>
        <div style={{ display: 'flex', gap: '12px', marginTop: '1.5rem', width: '100%' }}>
          <button className="auth-btn cancel-btn" onClick={onCancel}>
            Ні
          </button>
          <button className="auth-btn confirm-btn" onClick={onConfirm}>
            Так
          </button>
        </div>
      </div>
    </div>
  );
}
